import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dumbbell, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const StrengthConditioning = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  return (
    <div className="service-detail-page">
      {/* Hero Section */}
      <section className="service-hero">
        <div className="container">
          <div className="service-hero-content" data-aos="fade-up">
            <Dumbbell size={64} className="service-hero-icon" />
            <h1 className="display-large">Strength & Conditioning</h1>
            <p className="body-large">
              Build lean muscle mass, increase overall strength, and improve functional fitness 
              with structured progressive overload programs.
            </p>
            <Link to="/contact">
              <Button className="btn-cta">
                Book Free Consultation
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content-section">
        <div className="container">
          <div className="service-content-grid">
            <div className="service-image-large" data-aos="fade-right">
              <img 
                src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438" 
                alt="Strength & Conditioning Training" 
              />
            </div>
            
            <div className="service-details" data-aos="fade-left">
              <h2 className="heading-1">What You'll Achieve</h2>
              <p className="body-medium">
                My strength and conditioning programs are designed to help you build a strong, 
                functional body that performs well in daily life and athletic pursuits. Whether 
                you're new to resistance training or looking to break through plateaus, I'll create 
                a customized plan that progressively challenges you.
              </p>
              
              <div className="benefits-section">
                <h3 className="heading-2">Program Includes:</h3>
                <div className="benefits-list-detailed">
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Customized Workout Plans</h4>
                      <p className="body-small">Based on your experience level, goals, and available equipment</p>
                    </div>
                  </div>
                  
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Proper Form Coaching</h4>
                      <p className="body-small">Prevent injuries and maximize results with expert technique guidance</p>
                    </div>
                  </div>
                  
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Progressive Programming</h4>
                      <p className="body-small">Structured progression to ensure continuous gains and adaptation</p>
                    </div>
                  </div>
                  
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Strength Assessments</h4>
                      <p className="body-small">Regular testing and tracking to measure your progress</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta-section">
        <div className="container">
          <div className="service-cta-content" data-aos="fade-up">
            <h2 className="display-medium">Ready to Build Strength?</h2>
            <p className="body-large">
              Let's create a strength program that fits your goals and lifestyle.
            </p>
            <div className="service-cta-buttons">
              <Link to="/contact">
                <Button className="btn-cta">
                  Book Free Consultation
                  <ArrowRight className="ml-2" size={20} />
                </Button>
              </Link>
              <Link to="/services">
                <Button className="btn-secondary">
                  View All Services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StrengthConditioning;
